import { inject, Injectable } from '@angular/core';
import { ApiHelper } from '@core/api/api.helper';
import { ApiService } from '@core/api/api.service';
import { HttpResponse } from '@core/api/http-response.interface';
import { HttpStatusEnum } from '@core/api/http-status.enum';
import { FormatterHelper } from '@shared/helpers';
import { CurrentUser } from '@shared/types';

@Injectable({ providedIn: 'root' })
export class UserApi {
    private apiService = inject(ApiService);

    getCurrentUserDetails(): Promise<HttpResponse<CurrentUser>> {
        return new Promise<HttpResponse<CurrentUser>>(resolve => {
            this.apiService.get('admin-users/current-user-details').subscribe({
                next: (res: any) => {
                    const data: CurrentUser = {
                        userId: res.userId,
                        userName: res.userName,
                        firstName: res.firstName,
                        lastName: res.lastName,
                        fullName: FormatterHelper.computeUserFullName(res.firstName, res.lastName),
                        isColonySuperAdmin: res.isColonySuperAdmin,
                        isColonyGroupAdmin: res.isColonyGroupAdmin,
                        isColonyUserAdmin: res.isColonyUserAdmin,
                        isColonyMouseImportAdmin: res.isColonyMouseImportAdmin,
                        isTLAdmin: res.isTLAdmin,
                        isColonyWaiverAdmin: res.isColonyWaiverAdmin,
                    };
                    resolve({
                        status: HttpStatusEnum.SUCCESS,
                        data: data,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }
}
